export interface ISystemRecentPoints {
    pointIds: String;
}

export class SystemRecentPoints implements ISystemRecentPoints {
    pointIds: String;
    constructor(pointIds: String) {
        this.pointIds = pointIds;
    }
}


/** WEBPACK FOOTER **
 ** ./app/main/systemHealthRetriever/system-recent-points.ts
 **/